import type { OrderListItem, Id } from "../../types";

interface OrdersTableProps {
  orders: OrderListItem[];
  selectedOrderId: Id | null;
  orderDetailsLoading: boolean;
  onShowDetails: (order: OrderListItem) => void;
  resolveOrderDetailId: (order: OrderListItem) => Id | null;
  getOrderKey: (order: OrderListItem) => string;
  formatOrderLabel: (order: OrderListItem) => string;
  formatDateTime: (value?: string) => string;
  formatDate: (value?: string) => string;
  formatCurrency: (value?: number | null) => string;
  getOrderStatusLabel: (order: OrderListItem) => string;
}

const OrdersTable = ({
  orders,
  selectedOrderId,
  orderDetailsLoading,
  onShowDetails,
  resolveOrderDetailId,
  getOrderKey,
  formatOrderLabel,
  formatDateTime,
  formatDate,
  formatCurrency,
  getOrderStatusLabel,
}: OrdersTableProps) => (
  <table>
    <thead>
      <tr>
        <th>Numer</th>
        <th>Data złożenia</th>
        <th>Dostawa</th>
        <th>Status</th>
        <th>Pozycje</th>
        <th>Kwota brutto</th>
        <th>Akcje</th>
      </tr>
    </thead>
    <tbody>
      {orders.map((order) => {
        const detailId = resolveOrderDetailId(order);
        const isActive = detailId != null && detailId === selectedOrderId;
        const isLoadingDetails =
          orderDetailsLoading && detailId === selectedOrderId;

        return (
          <tr key={getOrderKey(order)} className={isActive ? "active" : ""}>
            <td data-label="Numer">{formatOrderLabel(order)}</td>
            <td data-label="Data złożenia">{formatDateTime(order.placedAt)}</td>
            <td data-label="Dostawa">
              {formatDate(order.deliveryDate) || "–"}
            </td>
            <td data-label="Status">{getOrderStatusLabel(order)}</td>
            <td data-label="Pozycje">{order.itemCount}</td>
            <td data-label="Kwota brutto">{formatCurrency(order.total)}</td>
            <td data-label="Akcje">
              <button
                type="button"
                className="secondary"
                onClick={() => onShowDetails(order)}
                aria-pressed={isActive}
                aria-busy={isLoadingDetails}
                disabled={isLoadingDetails}
              >
                Podgląd
                {isLoadingDetails && (
                  <span className="button-spinner" aria-hidden="true" />
                )}
              </button>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

export default OrdersTable;
